<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Reasons
    </h3>
    <i class="fa fa-info circle-icon"
      title="Clicking on legend entries toggles them from the graph. Empty graphs signify no data available. Filters from the table below work on this graph."></i>
  </div>
  <div class=" panel-body" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <div *ngFor="let reasonStat of aggregateCounts" class="reason-stat">
        <span class="reason-stat-label">{{ reasonStat.reason }}:</span>
        <span class="reason-stat-value">{{ reasonStat.count }}</span>
      </div>
    </div>

    <!-- Centered Title for Charts -->
    <div style="width: 100%; text-align: center; margin: 20px 0 10px 0;">
      <h4 style="margin: 0; font-size: 18px;">Reasons for cancelling - {{getTimePeriodText()}}</h4>
    </div>

    <!-- Charts Container -->
    <div style="display: flex; flex-direction: row; width: 100%; gap: 20px;">
      <div style="flex: 1; min-width: 400px;">
        <canvas id="reasonsChartCanvas">{{ reasonsChart }}</canvas>
      </div>
      <div style="flex: 1; min-width: 400px;">
        <canvas id="reasonsComparisonPieChartCanvas">{{ reasonsComparisonPieChart }}</canvas>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-list/exit-survey-statistics/exit-survey-statistics.component.html